export default __webpack_public_path__ + "static/media/sirius-leto.83d59e34.pdf";